import { FC } from 'react';
import { BreadcrumbItem } from '@doda/io-react/pc';
import styles from './index.module.scss';

export const BreadcrumbItemTop: FC = () => {
  return (
    <BreadcrumbItem className={styles.breadcrumbItemTop__item} href="/">
      転職・求人doda（デューダ）トップ
    </BreadcrumbItem>
  );
};
